import React from 'react';
import ReactDOM from 'react-dom';
import Error404 from './Shared/Error404';

if (document.getElementById("errormodel") !== null) {
    var countries = JSON.parse(document.getElementById("Layout").textContent).Model.Countries; // eslint-disable-next-line
    var error404Json = JSON.parse(document.getElementById("errormodel").textContent).Model; // eslint-disable-next-line
    ReactDOM.render(<Error404 errorJson={error404Json} countries={countries} />, document.getElementById('error404'));
}